import React from 'react';
import { DataTable } from '../../DataTable/DataTable';
import Table from '../../Table/Table';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import BulkRefundsColumns from './BulkRefundsColumns';
import useQueryBulkRefunds from '../hooks/useQueryBulkRefunds';
import Timer from '../../../Utils/Timer';
import AnalyticsEvent from '../../../services/analytics/AnalyticsEvent';
import Calendar from '../../DS/Calendar/Calendar';
import './bulkRefunds.scss';
import Pagination from '../../Table/Pagination';
import { useGetMerchant } from '../../../Utils/useGetMerchant';

const FORMAT_DATE_RANGE = 'yyyy-MM-dd';

const BulkRefunds = () => {
  const userMerchant = useGetMerchant();
  const { filters, queryResult, changePage, changePageSize, updateFilters } =
    useQueryBulkRefunds({
      initFilters: {
        merchantId: userMerchant.merchant_id,
        date: Timer().toNowISO(FORMAT_DATE_RANGE),
        page_size: 20,
        page: 1,
      },
    });

  const handleOnCleanFilters = () => {
    updateFilters({
      merchantId: userMerchant.merchant_id,
      page_size: 20,
      page: 1,
      date: Timer().toNowISO(FORMAT_DATE_RANGE),
    });
  };

  const onDownloadFile = fileUrl => {
    window.open(fileUrl, '_blank');
  };

  const onClickRow = async (row, columName) => {
    switch (columName) {
      case 'errors_file':
        AnalyticsEvent().bulkRefundReportError();
        onDownloadFile(row.errors_file, 'errors_file');
        break;
    }
  };

  const columns = React.useMemo(
    () =>
      BulkRefundsColumns({
        onClick: onClickRow,
      }),
    []
  );

  const handleChangePageSize = pageSize => {
    changePageSize(pageSize);
  };

  const handleChangePage = page => {
    changePage(page);
  };

  const table = useReactTable({
    data: queryResult.data ? queryResult.data.refunds : [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className='k-ds-width-full bulk-refunds'>
      <div className='k-ds-m-bottom-sp-02'>
        <h1 className='k-ds-heading-05'>Cancelaciones masivas</h1>
        <div className='k-ds-body-02 k-ds-m-bottom-sp-07'>
          Consulta el resumen de cancelaciones masivas.
        </div>
      </div>

      <div className='filters'>
        <div className='k-ds-heading-02'>Filtrar por:</div>

        <div className='selected-dates'>
          <Calendar
            formatDate={FORMAT_DATE_RANGE}
            value={filters.date}
            onClick={date => {
              updateFilters({
                date: date,
              });
            }}
          />
        </div>
      </div>

      <div>
        <DataTable>
          <Table table={table} onCleanFilter={handleOnCleanFilters} />
          <Pagination
            onChangePage={handleChangePage}
            onChangePageSize={handleChangePageSize}
            options={{
              totalElements:
                queryResult.data && queryResult.data.total_records
                  ? queryResult.data.total_records
                  : 0,
              totalPages:
                queryResult.data && queryResult.data.total_pages
                  ? queryResult.data.total_pages
                  : 1,
              currentPage: filters.page ? filters.page : 1,
            }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default BulkRefunds;
